<ng-container *ngIf="visible">
  <div
    class="navbar-item"
    [ngClass]="{ 'is-active': type === 'property_register' }"
  >
    <a
      class="is-flex is-align-items-center is-justify-content-center is-flex-direction-column"
      [routerLink]="['/properties/property_register']"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="19px"
        viewBox="0 -960 960 960"
        width="19px"
        fill="currentColor"
      >
        <path
          d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v400L600-120H200Zm360-80 200-200H560v200ZM280-400h200v-80H280v80Zm0-160h400v-80H280v80Z"
        />
      </svg>
      <span
        class="navbar-item-label"
        translationEditableDirective="PROPERTY_REGISTER"
        >{{ 'PROPERTY_REGISTER' | translate }}</span
      >
    </a>
  </div>
  <div
    class="navbar-item"
    *ngxPermissionsOnly="['STATUS_DATA_ENTRY']"
    [ngClass]="{ 'is-active': type === 'data_entry' }"
  >
    <a
      class="is-flex is-align-items-center is-justify-content-center is-flex-direction-column"
      [routerLink]="['/properties/data_entry']"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="19px"
        viewBox="0 -960 960 960"
        width="19px"
        fill="currentColor"
      >
        <path
          d="M280-280h80v-280h-80v280Zm160 0h80v-400h-80v400Zm160 0h80v-160h-80v160Zm80-320v-80h-80v-80h80v-80h80v80h80v80h-80v80h-80ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h360v200q0 33 23.5 56.5T640-560h200v360q0 33-23.5 56.5T760-120H200Z"
        />
      </svg>
      <span
        class="navbar-item-label"
        translationEditableDirective="DATA_ENTRY"
        >{{ 'DATA_ENTRY' | translate }}</span
      >
    </a>
  </div>
  <div
    class="navbar-item"
    *ngxPermissionsOnly="['STATUS_ASSESSMENT']"
    [ngClass]="{ 'is-active': type === 'assessment' }"
  >
    <a
      class="is-flex is-align-items-center is-justify-content-center is-flex-direction-column"
      [routerLink]="['/properties/assessment']"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="19px"
        viewBox="0 -960 960 960"
        width="19px"
        fill="currentColor"
      >
        <path
          d="m424-318 282-282-56-56-226 226-114-114-56 56 170 170ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h168q13-36 43.5-58t68.5-22q38 0 68.5 22t43.5 58h168q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm280-670q13 0 21.5-8.5T510-820q0-13-8.5-21.5T480-850q-13 0-21.5 8.5T450-820q0 13 8.5 21.5T480-790Z"
        />
      </svg>
      <span
        class="navbar-item-label"
        translationEditableDirective="ASSESSMENT"
        >{{ 'ASSESSMENT' | translate }}</span
      >
    </a>
  </div>
  <div
    class="navbar-item"
    *ngxPermissionsOnly="['STATUS_BILLING']"
    [ngClass]="{ 'is-active': type === 'billing' }"
  >
    <a
      class="is-flex is-align-items-center is-justify-content-center is-flex-direction-column"
      [routerLink]="['/properties/billing']"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="19px"
        viewBox="0 -960 960 960"
        width="19px"
        fill="currentColor"
      >
        <path
          d="M856-390 570-104q-12 12-27 18t-30 6q-15 0-30-6t-27-18L103-457q-11-11-17-25.5T80-513v-287q0-33 23.5-56.5T160-880h287q16 0 31 6.5t26 17.5l352 353q12 12 17.5 27t5.5 30q0 15-5.5 29.5T856-390ZM260-640q25 0 42.5-17.5T320-700q0-25-17.5-42.5T260-760q-25 0-42.5 17.5T200-700q0 25 17.5 42.5T260-640Z"
        />
      </svg>
      <span class="navbar-item-label" translationEditableDirective="BILLING">{{
        'BILLING' | translate
      }}</span>
    </a>
  </div>
  <div
    class="navbar-item"
    *ngxPermissionsOnly="['STATUS_OBJECTION']"
    [ngClass]="{ 'is-active': type === 'objection' }"
  >
    <a
      class="is-flex is-align-items-center is-justify-content-center is-flex-direction-column"
      [routerLink]="['/properties/objection']"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="19px"
        viewBox="0 -960 960 960"
        width="19px"
        fill="currentColor"
      >
        <path
          d="M300-360h60v-160h-60v50h-60v60h60v50Zm100-50h320v-60H400v60Zm200-110h60v-50h60v-60h-60v-50h-60v160Zm-360-50h320v-60H240v60Zm80 450v-80H160q-33 0-56.5-23.5T80-280v-480q0-33 23.5-56.5T160-840h640q33 0 56.5 23.5T880-760v480q0 33-23.5 56.5T800-200H640v80H320Z"
        />
      </svg>
      <span class="navbar-item-label" translationEditableDirective="APPEAL">{{
        'APPEAL' | translate
      }}</span>
    </a>
  </div>
  <div
    class="navbar-item"
    *ngxPermissionsOnly="['STATUS_ARCHIVED']"
    [ngClass]="{ 'is-active': type === 'archived' }"
  >
    <a
      class="is-flex is-align-items-center is-justify-content-center is-flex-direction-column"
      [routerLink]="['/properties/archived']"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="19px"
        viewBox="0 0 24 24"
        width="19px"
        fill="currentColor"
      >
        <path
          d="M3,3H21V7H3V3M4,8H20V21H4V8M9.5,11A0.5,0.5 0 0,0 9,11.5V13H15V11.5A0.5,0.5 0 0,0 14.5,11H9.5Z"
        />
      </svg>

      <span class="navbar-item-label" translationEditableDirective="ARCHIVED">{{
        'ARCHIVED' | translate
      }}</span>
    </a>
  </div>
</ng-container>
